<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" class="scaling-svg">
      <g id="Group_16" data-name="Group 16" transform="translate(-17.927 -0.927)">
        <circle
          id="Oval"
          cx="9"
          cy="9"
          r="9"
          transform="translate(18.427 1.427)"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RadioOffIcon extends Vue {}
</script>

<style>
</style>
